import React from "react";
import PropTypes from "prop-types";

import {
    Table,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from "semantic-ui-react";

const SubRow = ({ record }) => {
    return (
        <Table.Cell colSpan="7">
            <Table singleLine compact style={{ maxWidth: "40%" }}>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell className="TagsTable__MediumFixedWidth">
                            Sub-Tag Name
                        </TableHeaderCell>
                        <TableHeaderCell># Calls</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <Table.Body>
                    {record?.tags.map((item) => (
                        <TableRow key={item?.id}>
                            <Table.Cell style={{ border: "none" }}>
                                {item?.tag}
                            </Table.Cell>
                            <Table.Cell style={{ border: "none" }}>
                                {item?.count || 0}
                            </Table.Cell>
                        </TableRow>
                    ))}
                </Table.Body>
            </Table>
        </Table.Cell>
    );
};

SubRow.propTypes = {
    record: PropTypes.object.isRequired,
};

export default SubRow;
